import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { getHomepageConfig } from './Home.action';

const initialState = {
  dateRange: [moment().subtract(7, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
  config: {
    data: [],
    loading: false,
    error: false
  }
};

export const HomePageReducer = createSlice({
  name: 'homePage',
  initialState,
  reducers: {
    updateDateRange: (state, action) => {
      state.dateRange = action.payload;
    }
  },
  extraReducers: builder => {
    // ! Add home page api response in redux with - loading, success, error state
    builder
      .addCase(getHomepageConfig.pending, state => {
        state.config = {
          loading: true,
          error: false,
          data: []
        };
      })
      .addCase(getHomepageConfig.fulfilled, (state, action) => {
        state.config = {
          loading: false,
          error: false,
          data: action.payload || []
        };
      })
      .addCase(getHomepageConfig.rejected, state => {
        state.config = {
          loading: false,
          error: true,
          data: []
        };
      });
  }
});

export const { updateDateRange } = HomePageReducer.actions;

export default HomePageReducer.reducer;
